import * as locationsActions from '../actions/locations.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface LocationsState {
  locations: any;
  loading: boolean;
  loaded: boolean;
}

const initialState = {
  locations: null,
  loading: false,
  loaded: false,
};

export const locationsReducer = (state = initialState, action) => {
  switch(action.type) {
    case locationsActions.GET_LOCATIONS_LIST:
      return {
        ...state,
        loading: true,
        loaded: state.loaded
      };
    case locationsActions.GET_LOCATIONS_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: false,
      };
    case locationsActions.GET_LOCATIONS_LIST_SUCCESS:
      return {
        ...state,
        locations: action.payload,
        loading: false,
        loaded: true,
      };
    default: return state;
  }
};

export const getLocationsState = createFeatureSelector<LocationsState>('locationsReducer');

export const getLocationsList = (state) => state.locations;
export const locationsListLoaded = (state) => state.loaded;
